import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFoundPage = () => (
  <>
    <Helmet>
      <title>Page Not Found - Mato Industries</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6 py-24">
      <p className="text-6xl font-extrabold text-amber-500 mb-4">404</p>
      <h1 className="text-3xl font-extrabold text-navy-900 mb-3">Page Not Found</h1>
      <p className="text-slate-500 mb-8 max-w-md">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
      >
        Back to Home
      </Link>
    </div>
  </>
);

export default NotFoundPage;
